import * as React from "react";
const SvgEqualizer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={11}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      d="M0 2.25h5m4 0h3m0 6.163H7m-4 0H0M8.75 2.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm-5.5 6.163a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z"
    />
  </svg>
);
export default SvgEqualizer;
